import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private dataService: DataService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const requiredRoles = route.data['roles'] as string[];
    
    return this.dataService.userData$.pipe(
      take(1),
      map(userData => {
        if (!userData) {
          this.router.navigate(['/dang-nhap']);
          return false;
        }

        const userRoles = userData.role || [];
        
        console.log('User roles:', userRoles);
        console.log('Required roles:', requiredRoles);

        if (requiredRoles && requiredRoles.length > 0) {
          const hasRequiredRole = requiredRoles.some(requiredRole => 
            userRoles.includes(requiredRole)
          );
          
          if (!hasRequiredRole) {
            console.log('User does not have required role');
            this.router.navigate(['/unauthorized']);
            return false;
          }
        }

        return true;
      })
    );
  }
}